import axios from 'axios'

const instance = axios.create({
  baseURL: 'https://enigmatic-mesa-13390.herokuapp.com', //https://enigmatic-mesa-13390.herokuapp.com/
  timeout: 5000
});

export default instance;